<ng-container [ngSwitch]="fieldType">
  <!-- User field type -->
  <p-select #userSelect *ngSwitchCase="'user'" class="hide-chevron" [options]="userDropdownOptions"
    [placeholder]="''" [required]="isRequired" [disabled]="isReadOnly" optionLabel="label" optionValue="value"
    optionDisabled="disabled" [(ngModel)]="value" [name]="fieldName" (onShow)="onUserSelectShow()" (onHide)="onUserSelectHide()" (onChange)="onAssigneeChange($event.value)">
    <ng-template pTemplate="selectedItem" let-selectedOption>
      <div class="flex align-items-center gap-2" *ngIf="selectedOption; else userSelectPlaceholder">
        <div>{{ selectedOption.label }}</div>
      </div>
      <ng-template #userSelectPlaceholder>
        <span class="p-placeholder">{{ isUserOptionsLoading ? 'Loading...' : '' }}</span>
      </ng-template>
    </ng-template>
  </p-select>

  <!-- Date/Datetime field type -->
  <div *ngSwitchCase="'datetime'" class="detail-row__calendar">
    <p-datepicker #datetimePicker appendTo="body" [inputId]="fieldName + index" [showTime]="true" hourFormat="24"
      [hideOnDateTimeSelect]="false" [readonlyInput]="isReadOnly" [disabled]="isReadOnly" [showIcon]="true"
      [(ngModel)]="tempDate" [ngModelOptions]="{standalone: true}" (ngModelChange)="onDateChange($event)"
      dateFormat="dd M yy">
      <p-footer>
        <div class="calendar-footer-actions">
          <button type="button" mat-button (click)="onDateClear(datetimePicker)">Clear</button>
          <button type="button" mat-raised-button color="primary" (click)="onDateSet(datetimePicker)">Set</button>
        </div>
      </p-footer>
    </p-datepicker>
  </div>

  <div *ngSwitchCase="'date'" class="detail-row__calendar">
    <p-datepicker #datePicker appendTo="body" [inputId]="fieldName + index" [showTime]="false" [showIcon]="true"
      [hideOnDateTimeSelect]="false" [readonlyInput]="isReadOnly" [disabled]="isReadOnly" [(ngModel)]="tempDate"
      [ngModelOptions]="{standalone: true}" (ngModelChange)="onDateChange($event)" dateFormat="dd M yy">
      <p-footer>
        <div class="calendar-footer-actions">
          <button type="button" mat-button (click)="onDateClear(datePicker)">Clear</button>
          <button type="button" mat-raised-button color="primary" (click)="onDateSet(datePicker)">Set</button>
        </div>
      </p-footer>
    </p-datepicker>
  </div>

  <!-- Dropdown field type -->
  <ng-container *ngSwitchCase="'dropdownsingle'">
    <!-- Standard dropdown: plain text options -->
    <p-select *ngIf="isStandardDropdown; else styledDropdown" class="hide-chevron"
      [options]="standardDropdownOptions" [placeholder]="''" [required]="isRequired"
      [disabled]="isReadOnly" optionLabel="label" optionValue="value" [(ngModel)]="value" [name]="fieldName"
      (onChange)="onValueChange($event.value)">
    </p-select>

    <!-- Status/Priority/Styled dropdown: options rendered with their colors -->
    <ng-template #styledDropdown>
      <p-select class="hide-chevron styled-dropdown" [options]="styledDropdownOptions" [placeholder]="''"
        [required]="isRequired" [disabled]="isReadOnly" optionLabel="label" optionValue="value" [(ngModel)]="value"
        [name]="fieldName" (onChange)="onValueChange($event.value)">
        <ng-template pTemplate="selectedItem" let-opt>
          <span *ngIf="opt; else styledSelectPlaceholder" class="status-badge"
            [style.background-color]="opt.fillColor"
            [style.color]="opt.textColor"
            [style.border-color]="opt.borderColor"
            [style.border-width.px]="opt.borderThickness || 0"
            [style.border-style]="(opt.borderThickness || 0) > 0 ? 'solid' : 'none'">
            {{ opt.label }}
          </span>
          <ng-template #styledSelectPlaceholder>
            <span class="p-placeholder">Select</span>
          </ng-template>
        </ng-template>
        <ng-template pTemplate="item" let-opt>
          <span class="status-badge"
            [style.background-color]="opt.fillColor"
            [style.color]="opt.textColor"
            [style.border-color]="opt.borderColor"
            [style.border-width.px]="opt.borderThickness || 0"
            [style.border-style]="(opt.borderThickness || 0) > 0 ? 'solid' : 'none'">
            {{ opt.label }}
          </span>
        </ng-template>
      </p-select>
    </ng-template>
  </ng-container>

  <p-multiSelect *ngSwitchCase="'dropdownmultiple'" [options]="buildDropdownOptions(options)" [placeholder]="''"
    [required]="isRequired" [disabled]="isReadOnly" optionLabel="label" optionValue="value" [(ngModel)]="value"
    [name]="fieldName" (onPanelHide)="onValueChange(value)">
  </p-multiSelect>

  <!-- Checkbox field type -->
  <p-checkbox *ngSwitchCase="'checkbox'" [binary]="true" [disabled]="isReadOnly" [name]="fieldName" [(ngModel)]="value"
    (onChange)="onValueChange($event.checked)"> </p-checkbox>

  <!-- Memo field type -->
  <app-rich-text-field *ngSwitchCase="'memo'" [value]="value" [projectId]="projectId" [workspaceId]="workspaceId"
    [nodeInstanceId]="nodeInstanceId" [attachmentDialogContext]="'node'" [imageNamePrefix]="nodeKey" (valueChange)="value = $event" (blur)="onInputBlur($event)">
  </app-rich-text-field>

  <!-- FormattedText field type -->
  <ng-container *ngSwitchCase="'formattedtext'">
    <p-inputMask *ngIf="maskExpression; else noMaskFormattedText" [mask]="maskExpression" [(ngModel)]="value"
      [name]="fieldName" [disabled]="isReadOnly" [placeholder]="defaultText" (onComplete)="onInputBlur(value)"
      (onBlur)="onInputBlur(value)">
    </p-inputMask>
    <ng-template #noMaskFormattedText>
      <app-rich-text-field *ngIf="!isMasked; else maskedFormattedText" [value]="value" [projectId]="projectId"
        [workspaceId]="workspaceId" [nodeInstanceId]="nodeInstanceId" [attachmentDialogContext]="'node'" [imageNamePrefix]="nodeKey" (valueChange)="value = $event"
        (blur)="onInputBlur($event)">
      </app-rich-text-field>
      <ng-template #maskedFormattedText>
        <input pInputText [required]="isRequired" [readonly]="isReadOnly" [placeholder]="defaultText" [name]="fieldName"
          type="password" [(ngModel)]="value" (blur)="onInputBlur($any($event.target).value)"
          (keydown.enter)="onEnterSubmit($event, $any($event.target).value)" autocomplete="new-password" />
      </ng-template>
    </ng-template>
  </ng-container>

  <!-- Number field type -->
  <p-inputNumber *ngSwitchCase="'number'" [inputId]="'number_' + fieldId" [placeholder]="''"
    [required]="isRequired" [disabled]="isReadOnly" [name]="fieldName" [(ngModel)]="value" [showButtons]="true"
    [min]="min" [max]="max" (onBlur)="onValueChange(value)" (keydown.enter)="onEnterSubmit($event, value)">
  </p-inputNumber>

  <!-- URL field type -->
  <div *ngSwitchCase="'url'" class="url-field-wrapper">
    <input #urlInput pInputText [required]="isRequired" [maxlength]="maxLength" [readonly]="isReadOnly"
      [placeholder]="defaultText" [name]="fieldName" [type]="isMasked ? 'password' : 'url'" [(ngModel)]="value"
      [class.ng-invalid]="urlInvalid" (blur)="onUrlBlur(urlInput.value)"
      (keydown.enter)="onEnterSubmit($event, urlInput.value)" />
    <a *ngIf="isValidUrl" [href]="value" target="_blank" rel="noopener noreferrer" class="url-link-icon"
      title="Open link" (click)="$event.stopPropagation()">
      <i class="pi pi-external-link"></i>
    </a>
    <small *ngIf="urlInvalid" class="url-error">Please enter a valid URL (e.g., https://example.com)</small>
  </div>

  <!-- RadioButton field type -->
  <div *ngSwitchCase="'radiobuttongroup'" class="radio-group-container">
    <div *ngFor="let option of options; let optIndex = index" class="radio-option-item">
      <p-radioButton [name]="fieldName + index" [value]="option" [(ngModel)]="value"
        [inputId]="fieldName + index + '_' + optIndex" [disabled]="isReadOnly" (onClick)="onValueChange(value)">
      </p-radioButton>
      <label [for]="fieldName + index + '_' + optIndex" class="radio-option-label"
        [style.cursor]="isReadOnly ? 'default' : 'pointer'" [class.text-color-secondary]="isReadOnly">{{ option
        }}</label>
    </div>
  </div>

  <!-- Default: text input for text and any other types -->
  <input *ngSwitchDefault #defaultInput pInputText [required]="isRequired" [maxlength]="maxLength"
    [readonly]="isReadOnly" [placeholder]="defaultText" [name]="fieldName" [type]="isMasked ? 'password' : 'text'"
    [(ngModel)]="value" (blur)="onInputBlur(defaultInput.value)"
    (keydown.enter)="onEnterSubmit($event, defaultInput.value)" [autocomplete]="isMasked ? 'new-password' : 'off'" />
</ng-container>
